import React from 'react';
import {
  SEN_STAGES, SEN_STAGE_LABELS, REFERRAL_STAGES, REFERRAL_STAGE_LABELS, referralStageFor,
} from '../../utils/harbourPupils';
import './harbour.css';

/*
 * Harbour/Stage strip: the full row of pathway stages with one stage current,
 * earlier stages done and later stages upcoming. Both pathways have four
 * stages.
 *
 * A stopped pathway keeps the stage it reached, unchanged and not greyed out
 * (5327:403775 shows a referral withdrawn at In review still sitting at In
 * review); the stopping is carried by the chips and the banner above, never
 * by this strip. `currentKey` must therefore be a stage, not a stopped state
 * — callers pass referralBoardStage(row) or the lane's stageReached. A key
 * that names no stage falls back to the first rather than rendering nothing.
 */
export default function HarbourStageStrip({ pathway, currentKey }) {
  const isSen = pathway === 'sen';
  const stages = isSen ? SEN_STAGES : REFERRAL_STAGES;
  const labels = isSen ? SEN_STAGE_LABELS : REFERRAL_STAGE_LABELS;
  // A closed referral rests on Outcome available, the last stage it reached;
  // without this it would fall back to the first stage.
  const key = isSen ? currentKey : referralStageFor(currentKey);
  const currentIndex = Math.max(0, stages.indexOf(key));
  return (
    <div className="harbour-stage-strip" role="list" aria-label={`${pathway === 'sen' ? 'SEN' : 'Referral'} pathway stages`}>
      {stages.map((stage, i) => {
        const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'upcoming';
        return (
          <div
            key={stage}
            role="listitem"
            aria-current={state === 'current' ? 'step' : undefined}
            className={`harbour-stage-cell harbour-stage-cell--${pathway} harbour-stage-cell--${state}`}
          >
            <div className="harbour-stage-cell__bar" />
            <span className="harbour-stage-cell__label">{labels[stage]}</span>
          </div>
        );
      })}
    </div>
  );
}
